<template>
  <v-icon 
    size="12" 
    :class="[{'animation-isExpanded': isExpanded}, {'animation-isNotExpanded': !isExpanded}]"
  >
    {{icon}}
  </v-icon>
</template>

<script>

export default {
  name: 'ExpandedIcon',
  props: {
    icon: {type: String, default: 'fa-regular fa-angle-down'},
    isExpanded: {type: Boolean, required: true}
  }
}
</script>

<style scoped>
.animation-isExpanded {
  transition: transform 0.4s ease-in-out;
  transform: rotate(0deg);
}

.animation-isNotExpanded {
  transition: transform 0.4s ease-in-out;
  transform: rotate(-90deg);
}
</style>
